import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/monthClosingOverview',
        name: 'MonthClosingOverview',
        component: () => import(/* webpackChunkName: "monthClosingOverview" */ '../../src/modules/month/MonthClosingOverview'),
        meta: { moduleId: 'monthClosingOverview' },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/monthOfEmployees',
        name: 'MonthOverView',
        component: () => import(/* webpackChunkName: "monthofemployees" */ '@/modules/month/overview/components/MonthOverView'),
        meta: { moduleId: 'monthOfEmployees' },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/reopenMonth',
        name: 'ReopenMonthView',
        component: () => import(/* webpackChunkName: "reopenMonth" */ '../modules/month/reopen/ReopenMonthView'),
        meta: { moduleId: 'reopenMonth' },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthlyVerification',
        name: 'MonthlyVerificationView',
        component: () => import(/* webpackChunkName: "monthlyVerificationView" */ '../modules/month//MonthlyVerificationView'),
        meta: { 
            moduleId: 'monthlyVerificationView',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/calendar',
        name: 'CalendarView',
        component: () => import(/* webpackChunkName: "calendarView" */ '@/modules/month/calendar/CalendarView'),
        meta: { moduleId: 'monthCalendar' },
        beforeEnter: checkAuthenticated
    },
]
